import type { MovieItem } from '@/mocks/movies';
import MovieCard from './MovieCard';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  movies: MovieItem[];
  viewAllLink?: string;
  viewAllText?: string;
  accentColor?: 'primary' | 'accent';
}

export default function MovieGrid({ title, subtitle, movies, viewAllLink, viewAllText = '查看全部', accentColor = 'primary' }: MovieGridProps) {
  const accentClass = accentColor === 'primary'
    ? 'bg-primary-500'
    : 'bg-accent-500';

  return (
    <section className="px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className={`w-1 h-5 md:h-6 rounded-full ${accentClass}`}></div>
              <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">{title}</h2>
            </div>
            {subtitle && <p className="text-sm text-foreground-600 ml-3">{subtitle}</p>}
          </div>
          {viewAllLink && (
            <a
              href={viewAllLink}
              className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap"
            >
              {viewAllText}
              <i className="ri-arrow-right-line"></i>
            </a>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}